import { SortOption } from '@yes.technology/react-toolkit'
import { useEffect, useRef } from 'react'

const useInitialSortOptions = (
  initialOrderBy: SortOption[],
  setSortOptions: (sortOptions: SortOption[]) => void
) => {
  const prevOrderBy = useRef({})
  useEffect(() => {
    if (
      JSON.stringify(prevOrderBy.current) !== JSON.stringify(initialOrderBy)
    ) {
      setSortOptions(initialOrderBy)
      prevOrderBy.current = initialOrderBy
    }
  }, [initialOrderBy, setSortOptions])
}

export default useInitialSortOptions
